import { useState, useEffect } from "react";

export const useScroll = ({
  threshold,
}: {
  threshold: number;
}): [boolean, number] => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [scrollY, setscrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = window.scrollY;
      setscrollY(scrollHeight);
      setIsScrolled(scrollHeight > threshold);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [threshold]);

  return [isScrolled, scrollY];
};
